import { Avatar, Badge, Dropdown, Menu, Popover } from 'antd'
import { BaseButton } from 'components/elements/BaseButton'
import { BtnAnch } from 'components/elements/global'
import ChatReqNotiModal from 'features/chat/components/ChatReqNotiModal'
import {
 removeFromChatList,
 updateChatListPosition,
} from 'features/chat/reducer/ChatSlice'
import { TChatListData, TUnreadChatRequestData } from 'features/chat/types'
import { useAppDispatch } from 'hooks'
import useAppControl from 'hooks/useAppControl'
import { FC, useEffect, useMemo, useState } from 'react'
import Utils from 'utils/helper'

export const isValidChtCount = (v: any) => v !== undefined && v !== 0
const MinimizedChat: FC<{
 data: TChatListData[]
 chtNotiData?: TUnreadChatRequestData | null
}> = ({ data, chtNotiData }) => {
 const dispatch = useAppDispatch()
 const [chtItemsCount, setChtItemsCount] = useState(4)
 useEffect(() => {
  setChtItemsCount(isValidChtCount(chtNotiData?.count) ? 3 : 4)
 }, [chtNotiData])

 return (
  // <div className="chat-avatar-list">
  <div className="chat-avatar-list ">
   {(data?.length > 0 || chtNotiData?.count !== 0) && (
    <>
     {chtNotiData?.count !== undefined && chtNotiData?.count !== 0 && (
      <MinimizedChtNotiItem item={chtNotiData} />
     )}
     {data?.slice(0, chtItemsCount)?.map?.((item, key) => (
      <MinimizedChatItem
       onRemove={() => {
        dispatch(
         removeFromChatList({
          id: item.leadId,
         }),
        )
       }}
       onClick={() => {
        dispatch(
         updateChatListPosition({
          ...item,
          minimized: false,
          unReadCount: 0,
         }),
        )
       }}
       item={item}
       key={key}
      />
     ))}
     {data?.slice(chtItemsCount)?.length > 0 &&
      (data?.slice(chtItemsCount)?.length === 1 ? (
       <MinimizedChatItem
        onRemove={() => {
         dispatch(
          removeFromChatList({
           id: data.slice(chtItemsCount)[0].leadId,
          }),
         )
        }}
        onClick={() => {
         dispatch(
          updateChatListPosition({
           ...data.slice(chtItemsCount)[0],
           minimized: false,
          }),
         )
        }}
        item={data.slice(chtItemsCount)[0]}
       />
      ) : (
       <MoreMinimizedChatItem
        onClick={(v) => {
         dispatch(
          updateChatListPosition({
           ...v,
           minimized: false,
          }),
         )
        }}
        onRemove={(id) => {
         dispatch(removeFromChatList({ id }))
        }}
        data={data.slice(chtItemsCount)}
       />
      ))}
    </>
   )}
  </div>
 )
}

export default MinimizedChat

const MinimizedChatItem: FC<{
 item: TChatListData
 onClick?: () => void
 onRemove?: () => void
}> = ({ item, onClick, onRemove }) => {
 return (
  <Popover
   className="minimized-chat-item"
   placement="right"
   content={item?.leadName || ''}
  >
   <BaseButton
    onClick={onRemove}
    title="Remove"
    shape="circle"
    size="small"
    type="link"
    icon={<i className="far fa-times" />}
   />
   <Badge offset={[-45, 10]} count={item.unReadCount}>
    <div
     onClick={onClick}
     role="button"
     tabIndex={0}
     onKeyDown={(e) => {
      if (e.key === 'Enter' || e.key === ' ') {
       e.preventDefault()
       onClick?.()
      }
     }}
    >
     <Avatar
      className="bg-primary"
      icon={Utils.shortName(item?.leadName || '')}
      size={50}
     />
    </div>
   </Badge>
  </Popover>
 )
}

const MinimizedChtNotiItem: FC<{
 item: TUnreadChatRequestData
}> = ({ item }) => {
 const { data } = item || {}
 const { updateControl } = useAppControl()
 const [showModal, setShowModal] = useState(false)
 const isDirectChatReq = !item?.is_group_chat
 const onRemove = (ids?: string[]) => {
  // readChatRequest({ notification_id: ids as any })
  // updateControl({ chtNotiPopup: null })
 }

 useEffect(() => {
  if (item?.count === 0) {
   setShowModal(false)
  }
 }, [item?.count])

 return (
  <>
   <Popover
    className="minimized-chat-item"
    placement="right"
    content={data?.title ?? ''}
   >
    <BaseButton
     onClick={() => onRemove(item?.notification_ids)}
     title="Remove"
     shape="circle"
     size="small"
     type="link"
     icon={<i className="far fa-times" />}
    />
    <Badge offset={[-45, 10]} count={item?.count}>
     <Avatar
      //  src={item.proData?.images?.[0]}
      // src={isDirectChatReq ? undefined : data?. ?? ''}
      // onClick={() => setShowModal(true)}
      className="bg-primary"
      // icon={isDirectChatReq ? Utils.shortName(data?.dat || '') : 'v'}
      size={50}
     />
    </Badge>
   </Popover>
   {showModal && (
    <ChatReqNotiModal
     show={showModal}
     onHide={() => setShowModal(false)}
     item={item}
     isDirectChat={isDirectChatReq}
    />
   )}
  </>
 )
}

const MoreMinimizedChatItem: FC<{
 data: TChatListData[]
 onRemove?: (id: any) => void
 onClick?: (val: TChatListData) => void
}> = ({ data, onRemove, onClick }) => {
 const totalUnreadCount = useMemo(
  () => data.reduce((acc, curr) => acc + (curr.unReadCount || 0), 0),
  [data],
 )

 return (
  <Dropdown
   trigger={['click']}
   placement="bottomLeft"
   overlay={
    <Menu
     className="more-chat-menus"
     items={data.map((v) => ({
      type: 'group',
      label: (
       <div className="more-chat-menu">
        <BtnAnch onClick={() => onClick?.(v)} className="more-chat--link">
         {v?.leadName}
        </BtnAnch>
        <Badge size="small" count={v.unReadCount} />
        <BtnAnch className="remove---item" onClick={() => onRemove?.(v?.id)}>
         <i className="fas fa-times" />
        </BtnAnch>
       </div>
      ),
      key: v?.leadId,
     }))}
    />
   }
   className="minimized-chat-item"
  >
   <Badge offset={[-45, 10]} count={totalUnreadCount}>
    <Avatar
     className="bg-primary"
     icon={
      <div className="minimized-chat-item-more">
       <div className="text">{`+${data.length}`}</div>{' '}
       <div style={{ position: 'absolute', inset: 0 }}>
        {Utils.shortName(data?.[0]?.leadName ?? '')}{' '}
       </div>
      </div>
     }
     size={50}
    />
   </Badge>
  </Dropdown>
 )
}
